import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { applyLanguage } from "@/i18n";
import { meQuery } from "@/lib/queries";

/** Pathless layout for all signed-in pages; redirects to /login without a session. */
export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (!me) {
      throw redirect({
        to: "/login",
        search: location.href === "/" ? {} : { redirect: location.href },
      });
    }
    applyLanguage(me.locale);
    return { me };
  },
  component: AppLayout,
});

function AppLayout() {
  return <AppShell />;
}
